import styled from "@emotion/styled"
import { PCheckbox } from "@porsche-design-system/components-react"
import type { CheckboxChangeEventDetail } from "@porsche-design-system/components-react"
import type { MessageDescriptor } from "react-intl"
import { porscheApprovedMessages } from "src/common/messages/porscheApproved.messages"
import { Tooltip } from "src/components"
import { DisablementReasonList } from "./DisablementReasonList"

interface PorscheApprovedCheckboxProps {
	checked: boolean | undefined
	disablementReasons: MessageDescriptor[]
	label?: string
	onChange: (checked: boolean) => void
}

export const PorscheApprovedCheckbox = (props: PorscheApprovedCheckboxProps) => {
	const { checked, disablementReasons, label, onChange } = props

	return (
		<Tooltip
			content={
				disablementReasons.length > 0 && (
					<DisablementReasonList
						disablementLabel={porscheApprovedMessages.violationReasonsLabel}
						disablementReasons={disablementReasons}
					/>
				)
			}
			data-testid="porsche-approved-checkbox-tooltip"
		>
			<StyledCheckbox
				label={label}
				checked={checked}
				disabled={disablementReasons.length > 0}
				onChange={(e: CustomEvent<CheckboxChangeEventDetail>) =>
					onChange((e.target as HTMLInputElement).checked)
				}
				data-testid="porsche-approved-checkbox"
			/>
		</Tooltip>
	)
}

const StyledCheckbox = styled(PCheckbox)`
	justify-self: start; /* to center tooltip on actual content, not the available width */
`
